import { render, staticRenderFns } from "./modal-approve.vue?vue&type=template&id=e29604d6&"
import script from "./modal-approve.vue?vue&type=script&lang=js&"
export * from "./modal-approve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports